module.exports = __webpack_public_path__ + "media/honey-icons/icon-mode-settings-5a4e2d9b.svg";